import fp from 'lodash/fp';
import { LOCATION_CHANGE } from 'react-router-redux';
import { combineActions, handleActions } from 'redux-actions';
import { updateIn } from '../../../../utils';
import actions from './actions';

export const initialState = {
  content: {
    contentResult: {
      content: [],
      total: 0,
      hits: 0,
      take: 0,
      skip: 0
    },
    contentQuestions: [],
    contentPassedUserEmails: [],
    selectedContent: null,
    isFetching: false,
    isLoadingMore: false,
    saveQuestionSuccess: false,
    error: null
  }
};

const extendState = (state, newState) => ({
  ...state,
  content: {
    ...state.content,
    ...newState
  }
});

export const reducerDefinition = {
  [actions.publisherPortal.content.api.get.request]: (state, action) =>
    extendState(state, {
      isFetching: true
    }),
  [actions.publisherPortal.content.api.get.success]: (state, action) =>
    extendState(state, {
      isFetching: false,
      contentResult: action.payload.contentResult,
      error: null
    }),
  [actions.publisherPortal.content.api.getById.success]: (state, action) =>
    extendState(state, {
      isFetching: false,
      selectedContent: action.payload.content
    }),
  [actions.publisherPortal.content.resetSelectedContent]: (state, action) =>
    extendState(state, {
      selectedContent: null
    }),
  [combineActions(
    actions.publisherPortal.content.api.addContent.request,
    actions.publisherPortal.content.api.updateContent.request)]: (state, action) =>
      extendState(state, {
        isFetching: true,
        error: null
      }),
  [combineActions(
    actions.publisherPortal.content.api.addContent.success,
    actions.publisherPortal.content.api.updateContent.success)]: (state, action) =>
      extendState(state, {
        isFetching: false,
        lastSavedContentType: action.payload.content.contentType,
        error: null
      }),
  [combineActions(
    actions.publisherPortal.content.api.getById.failed,
    actions.publisherPortal.content.api.addContent.failed,
    actions.publisherPortal.content.api.updateContent.failed)]: (state, action) =>
      extendState(state, {
        isFetching: false,
        error: action.payload.error
      }),
  [actions.publisherPortal.content.api.loadMore.request]: (state, action) =>
    extendState(state, {
      isFetching: true,
      isLoadingMore: true
    }),
  [actions.publisherPortal.content.api.loadMore.success]: (state, action) => {
    const { contentResult } = action.payload;
    const content = fp.concat(state.content.contentResult.content, contentResult.content);

    return extendState(state, {
      isFetching: false,
      isLoadingMore: false,
      contentResult: {
        ...contentResult,
        content
      },
      error: null
    });
  },
  [combineActions(actions.publisherPortal.content.api.get.failed,
    actions.publisherPortal.content.api.loadMore.failed)]: (state, action) =>
      extendState(state, {
        isFetching: false,
        isLoadingMore: false,
        error: action.payload.error
      }),
  [combineActions(actions.publisherPortal.content.api.addQuestion.request,
    actions.publisherPortal.content.api.updateQuestion.request,
    actions.publisherPortal.content.api.deleteQuestion.request)]: (state, action) =>
      extendState(state, {
        saveQuestionSuccess: false,
        error: null
      }),
  [actions.publisherPortal.content.api.addQuestion.success]: (state, action) =>
    extendState(state, {
      saveQuestionSuccess: true,
      contentQuestions: fp.concat(state.content.contentQuestions)(action.payload.question),
      error: null
    }),
  [actions.publisherPortal.content.api.updateQuestion.success]: (state, action) =>
    extendState(state, {
      saveQuestionSuccess: true,
      contentQuestions: updateIn(state.content.contentQuestions, action.payload.question, 'id'),
      error: null
    }),
  [actions.publisherPortal.content.api.deleteQuestion.success]: (state, action) =>
    extendState(state, {
      contentQuestions: fp.filter((q) => q.id !== action.payload.deleted.id)(state.content.contentQuestions),
      error: null
    }),
  [combineActions(actions.publisherPortal.content.api.addQuestion.failed,
    actions.publisherPortal.content.api.updateQuestion.failed)]: (state, action) =>
      extendState(state, {
        saveQuestionSuccess: false,
        error: 'Question did not add for the content, Please try again.'
      }),
  [actions.publisherPortal.content.api.getContentQuestions.success]: (state, action) =>
    extendState(state, {
      contentQuestions: action.payload.questions || []
    }),
  [actions.publisherPortal.content.api.getContentPassedUserEmails.success]: (state, action) =>
    extendState(state, {
      contentPassedUserEmails: action.payload.passedUserEmails || []
    }),
  [LOCATION_CHANGE]: (state, action) =>
    extendState(state, {
      error: null,
      isFetching: false
    })
};

export default handleActions(reducerDefinition, { ...initialState });



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/content/reducers.js